import { PrinterPosWrenchOutlineIcon } from './PrinterPosWrenchOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C998386E-C3FA-44DC-9513-D2BFA68D7D12
 * name printer-pos-wrench-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-wrench-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptWrenchOutlineIcon = PrinterPosWrenchOutlineIcon;
export default PrinterReceiptWrenchOutlineIcon